import { TYPES } from "./finance_reseller.type";
import dayjs from "dayjs";

const initState = {
  financeResellerAll: null,
  financeResellerOpenAdd: false,
  financeResellerOpenEdit: false,
  financeResellerSelected: null,
  financeResellerSearch: "",
  //
  financeResellerDates: [dayjs().subtract(1, "months"), dayjs()],
};

const financeResellerReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_FINANCE_RESELLER_ALL:
      return {
        ...state,
        financeResellerAll: payload,
      };

    case TYPES.SET_FINANCE_RESELLER_OPEN_ADD:
      return {
        ...state,
        financeResellerOpenAdd: payload,
      };

    case TYPES.SET_FINANCE_RESELLER_OPEN_EDIT:
      return {
        ...state,
        financeResellerOpenEdit: payload,
      };

    case TYPES.SET_FINANCE_RESELLER_SELECTED:
      return {
        ...state,
        financeResellerSelected: payload,
      };

    case TYPES.SET_FINANCE_RESELLER_SEARCH:
      return {
        ...state,
        financeResellerSearch: payload,
      };

    case TYPES.SET_FINANCE_RESELLER_DATES:
      return {
        ...state,
        financeResellerDates: payload,
      };

    default:
      return state;
  }
};

export default financeResellerReducer;
